import React from "react";
import { FaLock, FaWindowMinimize } from "react-icons/fa";
import { LockMessage, LockTitle, LockTitleSpan } from "./LockedWindowStyles";

interface ILockMessageWindowProps {
  lockMessageExpanded?: boolean;
}

const lockTitle = "This object is locked!";

const lockMessage = `Locking an object prevents accidental changes from being made 
  once it has been rolled out. All patches will fail to be applied
  until the object has been unlocked. If you wish to unlock this 
  object, please contact a Salt ADAPTIVE administrator.`;

export const LockMessageWindow = (props: ILockMessageWindowProps) => {
  const [expanded, setExpanded] = React.useState(props.lockMessageExpanded || true);

  const toggleLockMessage = () => setExpanded(!expanded);

  return (
    <LockMessage>
      <LockTitle>
        <LockTitleSpan>
          <FaLock />
          {lockTitle}
        </LockTitleSpan>
        <FaWindowMinimize onClick={toggleLockMessage} />
      </LockTitle>
      {expanded && <p>{lockMessage}</p>}
    </LockMessage>
  );
};
